import React from "react";
import DirectoryCard from "./DirectoryCard";

const Directory = () => {
  return (
    <div className=" flex flex-col justify-center items-center my-8 md:my-20 gap-y-6">
      <DirectoryCard />

      <div className="grid grid-cols-1 gap-y-6 md:grid-cols-2 gap-x-4">
        <DirectoryCard />
        <DirectoryCard />
        <DirectoryCard />
        <DirectoryCard />
        <DirectoryCard />
        <DirectoryCard />
        <DirectoryCard />
        <DirectoryCard />
        <DirectoryCard />
        <DirectoryCard />
      </div>
    </div>
  );
};

export default Directory;
